export const INSPIRATION_MODAL_ID = 'inspiration-modal';
